import { useNavigate } from "react-router-dom";
import { useAuth } from "@/App";
import { Button } from "@/components/ui/button";
import { LogOut, Mail } from "lucide-react";

const LOGO_URL = "/logo-infirmiers.png";
const CONTACT_EMAIL = "soins@infirmiersprives.fr";

export default function PatientWelcome() {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  return (
    <div className="min-h-screen bg-[#0D1C32] flex items-center justify-center px-4 py-12" data-testid="patient-welcome-screen">
      <div className="w-full max-w-xl text-center">
        <img src={LOGO_URL} alt="Infirmiers Privés" className="h-14 w-auto mx-auto mb-10" />

        <div className="bg-[#1F2A38] border border-[#2A3A4D] rounded-2xl px-8 py-12 sm:px-12">
          {/* Français */}
          <h1 className="text-2xl sm:text-3xl font-semibold text-white leading-snug">
            Merci pour votre inscription ! <span aria-hidden>🎉</span>
          </h1>
          <p className="mt-5 text-base text-[#CBD5E1] leading-relaxed">
            Notre plateforme est en cours de développement. Pour toute demande d'intervention,
            envoyez-nous simplement un e-mail à{" "}
            <a
              href={`mailto:${CONTACT_EMAIL}`}
              className="text-[#00E073] font-medium hover:underline"
              data-testid="welcome-email-link-fr"
            >
              {CONTACT_EMAIL}
            </a>
            . Nous nous occupons de vous rediriger vers les infirmiers partenaires les plus proches de vous.
          </p>

          <div className="my-8 h-px bg-[#2A3A4D]" />

          {/* English */}
          <h2 className="text-lg sm:text-xl font-semibold text-white leading-snug">
            Thank you for registering! <span aria-hidden>🎉</span>
          </h2>
          <p className="mt-4 text-sm text-[#94A3B8] leading-relaxed">
            Our platform is currently under development. For any care requests, simply send us an email at{" "}
            <a
              href={`mailto:${CONTACT_EMAIL}`}
              className="text-[#00E073] font-medium hover:underline"
              data-testid="welcome-email-link-en"
            >
              {CONTACT_EMAIL}
            </a>
            . We will take care of routing you to the nearest partner nurses.
          </p>

          <div className="mt-10 flex justify-center">
            <a
              href={`mailto:${CONTACT_EMAIL}`}
              className="inline-flex items-center gap-2 bg-[#00E073] text-[#0D1C32] font-semibold text-sm px-6 py-3 rounded-full hover:bg-[#00c765] transition-colors"
              data-testid="welcome-email-cta"
            >
              <Mail className="w-4 h-4" />
              {CONTACT_EMAIL}
            </a>
          </div>
        </div>

        <Button
          variant="ghost"
          onClick={handleLogout}
          className="mt-8 text-[#94A3B8] hover:text-white hover:bg-[#1F2A38]"
          data-testid="welcome-logout-btn"
        >
          <LogOut className="w-4 h-4 mr-2" />
          Se déconnecter / Log out
        </Button>
      </div>
    </div>
  );
}
